export default __webpack_public_path__ + "static/media/endocrine-shadow.14e9f7b0.svg";